import React from "react";
import mindTreeLogo from "../../images/mindtree-logo copy/png/mindtree-logo copy.png";

const Notify = (props) => {
  /**
   * The function `getStatusBackgroundColor` takes a status parameter and returns a corresponding
   * background color based on the status value.
   * @param status - The `status` parameter is a string that represents the status of something.
   * @returns a string representing the background color based on the given status.
   */
  function getStatusBackgroundColor(status) {
    if (status === 'work-in-progress') {
      return 'bg-[#F5A623]';
    } else if (status === 'open' || status === '' || status === null) {
      return 'bg-[#4A90E2]';
    } else if (status === 're-opened') {
      return 'bg-[#EF4E3E]';
    } else if (status === 'closed') {
      return 'bg-[#38B449]';
    } else {
      return 'bg-transparent';
    }
  }
  const cleanDescription = (content) => {
    // Remove link and hyphen: everything before and including ' - '
    const parts = content.split(' - ');
    return parts.length > 1 ? parts.slice(1).join(' - ') : content;
  };
  

  /**
   * The function takes a status parameter and returns a corresponding status label.
   * @param status - The parameter "status" is a string that represents the current status of a task or
   * issue.
   * @returns the status of a task or issue.
   */
  function getStatus(status) {
    if (status === 'work-in-progress') {
      return 'In-progress';
    } else if (status === 'open' || status === '' || status === null) {
      return 'Open';
    } else if (status === 're-opened') {
      return 'Reopen';
    } else if (status === 'closed') {
      return 'Closed';
    } else {
      return '';
    }
  }

  /**
   * Determines if a notification is read or unread
   * @param notification - The notification object to check
   * @returns boolean indicating if the notification has been read
   */
  function isRead(notification) {
    return notification.read_at !== undefined && notification.read_at !== null;
  }

  return (
    <div className="">
      <ul className="divide-y">
        {props.notificationData && (!props.notificationData.read_and_unread || 
            props.notificationData.read_and_unread.length < 1) ? (
          <li className="lg:text-[15px] text-[15px] text-[#333333] relative mt-[14rem] text-center">
            No notifications
          </li>
        ) : (
          props.notificationData.read_and_unread.map((data, i) => (
            <li 
              className={`py-2 pl-[1.75rem] cursor-pointer hover:bg-gray-200 ${!isRead(data) ? 'font-bold' : ''}`} 
              onClick={() => props.handleNotificationClick(data, false, 'request')} 
              key={i}
            >
              <div className="flex space-x-2">
                <img
                  className="h-6 w-6 rounded-full mt-2"
                  src={mindTreeLogo}
                  alt=""
                />
                <div className="flex-1 pt-2">
                  <div className="flex items-center justify-between">
                    <h3 className="text-[14px] text-[#333333] font-SequelSans tracking-[-0.26px] leading-[17px]">
                      {data.entity_name}
                    </h3>
                    <div className="flex items-center space-x-2 px-4">
                      <p className="text-[11px] font-SequelSans text-[#888888] leading-[12px] tracking-[-0.24px]">
                        {data.notified_at}
                      </p>
                      <span
                        className={`flex-shrink-0 rounded-full ${getStatusBackgroundColor(data.status)} inline-flex items-center justify-center h-1 w-1 p-1`}
                        aria-hidden="true"
                      ></span>
                      <p className="text-[14px] font-SequelSans leading-[17px] tracking-[-0.26px] text-[#333333]">
                        {getStatus(data.status)}
                      </p>
                    </div>
                  </div>

                  {/* Remove Author */}
                  {/* <p className="text-[13px] font-SequelSans leading-[16px] tracking-[0.32px] text-[#888888]">
                    {data.sent_by}
                  </p> */}

                  {/* Cleaned + Truncated Content */}
                  <em className="text-[13px] font-SequelSans text-[#333333] pt-1 leading-[18px] tracking-[-0.32px] line-clamp-2 overflow-hidden">
                    {cleanDescription(data.entity_content)}
                  </em>
                </div>
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default Notify;